import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  signOut ,signInWithRedirect
} from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBS5YV2H0-K424m6TlDA2eg2fvgAMSmB8k",
  authDomain: "tgh-user.firebaseapp.com",
  projectId: "tgh-user",
  storageBucket: "tgh-user.firebasestorage.app",
  messagingSenderId: "369424539029",
  appId: "1:369424539029:web:dab3df5d986b35e8c7aa9c"
};


const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();
const storage = getStorage(app);


const googleLogin = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    console.log(result)
    const user = result.user;


    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      await setDoc(userRef, {
        name: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
        createdAt: new Date(),
      });
      console.log("User signed up:", user);
    } else {
      console.log("User signed in:", user);
    }

    return user;
  } catch (error) {
    console.error("Google Sign-In Error:", error.message);
  }
};


const logout = () => signOut(auth);

export { auth, googleLogin, logout, storage, messaging, getToken, onMessage };
